import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import LandingPage from "./pages/LandingPage";
import DatasetCatalogue from "./pages/DatasetCatalogue";
import ContactPage from "./pages/ContactPage";
import CapturePage from "./pages/tech/CapturePage";
import LabelsPage from "./pages/tech/LabelsPage";
import QualityPage from "./pages/tech/QualityPage";
import ModelsPage from "./pages/tech/ModelsPage";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); return undefined; }
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView(), 300);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
}

// Old URLs forward to new ones, keeping any #filters or #anchor
const Redirect = ({ to, hash }) => {
  const loc = useLocation();
  return <Navigate replace to={to + (hash || loc.hash)} />;
};

const REDIRECTS = [
  ["/datasets", "/data/showcase"],
  ["/data", "/data/showcase"],
  ["/technology", "/technology/capture"],
  ["/technology/capture-system", "/technology/capture"],
  ["/technology/metadata", "/technology/labels", "#metadata"],
  ["/technology/quality-control", "/technology/quality"],
  ["/technology/models", "/technology/benchmarks"],
];

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="noise-overlay" aria-hidden="true" />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/data/showcase" element={<DatasetCatalogue />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/technology/capture" element={<CapturePage />} />
        <Route path="/technology/labels" element={<LabelsPage />} />
        <Route path="/technology/quality" element={<QualityPage />} />
        <Route path="/technology/benchmarks" element={<ModelsPage />} />
        {REDIRECTS.map(([from, to, hash]) => <Route key={from} path={from} element={<Redirect to={to} hash={hash} />} />)}
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
